import { render, staticRenderFns } from "./PackagePlans.vue?vue&type=template&id=4bc8e332&"
import script from "./PackagePlans.vue?vue&type=script&lang=js&"
export * from "./PackagePlans.vue?vue&type=script&lang=js&"
import style0 from "./PackagePlans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackagePlans.vue"
export default component.exports